import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { TixService } from 'wanderu-service-wapi';

import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';
import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';

const logger = Logger.getLogger('wanderu-app-booking:makeDetailsCall');

function makeDetailsCall(state, component, adyenActions) {
    return async (dispatch, getState) => {
        await dispatch(actions.reset());

        dispatch(actions.startWork());

        let error;
        let meta;
        try {
            dispatch(bookingActions.setDetails(state?.data?.details));

            const {
                bookingSessionId,
            } = bookingSelectors.selectBookingInfo(getState());

            const body = {
                ...state.data,
                booking_session_id: bookingSessionId,
            };

            // Make a POST /payments/details request from your server.
            const { result, error: adyenError } = await TixService.post('v4/book/payment/challenge', { body });

            // If the /payments/details request from your server fails, or if an unexpected error occurs.
            if (!result?.details?.resultCode) {
                adyenActions.reject(adyenError);
                return;
            }

            const {
                action,
                donationToken,
                order,
                resultCode,
            } = result.details;

            // If the /payments/details request request from your server is successful, you must call this to resolve whichever of the listed objects are available.
            // You must call this, even if the result of the payment is unsuccessful.
            adyenActions.resolve({
                action,
                donationToken,
                order,
                resultCode,
            });
        } catch (ex) {
            error = ex?.responseBody?.error || ex;

            adyenActions.reject(error);

            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
        } finally {
            dispatch(actions.endWork(undefined, meta, error));
        }
    };
}

const makeDetailsCallAction = {
    fetch: makeDetailsCall,
    ...actions,
    ...selectors,
};

export {
    makeDetailsCallAction,
};

export default {
    [namespace]: reducer,
};
